/*
 * @Author: zxf
 * @Date: 2021-11-10 18:04:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-26 16:45:31
 * @Description: 单例对象,管理地图中所有的工具
 * @FilePath: \neolix-map-sdk\src\tool\ToolController.js
 */
import Controller from '../clazz/Controller';
import { EventController } from './../utils/EventController.js';
export class ToolController extends Controller {
    /**
     * 初始化方法
     * @method constructor
     * @author zxf
     * @date   2021-11-25
     * @return {undefined}
     */
    constructor() {
        super();

        this.viewer = null;
        
		this.renderer = null;

		this.domElement = null;
        
        this.eventController = EventController.getInstance();

        this.dblClickTimeInterval = 300;

        this.dblClickDisInterval = 1;

        this.lastClickTime = null;

        // 所有注册的工具,不包含后台工具
        this.tools = {};

        // 当前的工具
        this.currentTool = null;

        // 指示当前工具是否运行,对背景后台工具无效
        this.isRunning = true;

        this.tagNames = {
            INPUT: true,
            BUTTON: true,
            TEXTAREA: true,
        };

        //记录按键code变化
	    this.keyEventCode = null;
    }

    /**
     * 将此实例对象添加到map中
     * @param {object} obj 添加到的对象
     */
    addTo(viewer) {
        this.viewer = viewer;
        this.renderer = viewer.renderer;
        this.domElement = this.renderer.domElement;
        this.renderArea = viewer.renderArea;
    }

    bindEvent() {
        // 将键盘事件绑定到dom上，并根据event.target决定是否触发工具响应
        this.renderArea.addEventListener('keydown', this._onKeyDown.bind(this));
        this.renderArea.addEventListener('keyup', this._onKeyUp.bind(this));
        this.renderArea.addEventListener('mousedown', this._onMouseDown.bind(this));
        this.renderArea.addEventListener('mousemove', this._onMouseMove.bind(this));
        this.renderArea.addEventListener('mouseup', this._onMouseUp.bind(this));
        this.renderArea.addEventListener('pointerdown', this._onPointerdown.bind(this));
        this.renderArea.addEventListener('pointermove', this._onPointermove.bind(this));
        this.renderArea.addEventListener('pointerup', this._onPointerup.bind(this));
      }

    unBindEvent() {
        // 给工具解绑事件
        this.renderArea.removeEventListener('keydown', this._onKeyDown);
        this.renderArea.removeEventListener('keyup', this._onKeyUp);
        this.renderArea.removeEventListener('mousedown', this._onMouseDown);
        this.renderArea.removeEventListener('mousemove', this._onMouseMove);
        this.renderArea.removeEventListener('mouseup', this._onMouseUp);
        this.renderArea.removeEventListener('pointerdown', this._onPointerdown);
        this.renderArea.removeEventListener('pointermove', this._onPointermove);
        this.renderArea.removeEventListener('pointerup', this._onPointerup);
    }

    /**
     * @Author: zxf
     * @description: 添加工具,不激活工具, 如果工具已经存在则忽略
     * @param {*}
     * @return {*}
     */
    addTool(tool) {
        if (this.tools.hasOwnProperty(tool.name)) {
            return;
        }
        this.tools[tool.name] = tool;
    }

    /**
     * @Author: zxf
     * @description: 删除工具
     * @param {*}
     * @return {*}
     */
    delTool(toolName) {
        if (!this.tools.hasOwnProperty(toolName)) {
            return;
        }

        if (toolName === this.currentTool.name) {
            this.currentTool.onDeactive();
            this.currentTool = null;
        }

        const tool = this.tools[toolName];

        delete this.tools[toolName];
    }

    /**
     * 根据名称设置当前工具
     * @method resetCurrentTool
     * @author zxf
     * @date   2021-11-25
     * @param  {object} options 可选对象
     * @return {boolean} 布尔值
     */
    resetCurrentTool(toolName, options) {
        this.continue();

        if (!this.tools.hasOwnProperty(toolName)) {
            return false;
        }

        const tool = this.tools[toolName];
        if (this.currentTool) {
            this.currentTool.onDeactive();
        }

        tool.onActive(options);

        if(tool.start) {
            tool.start();
        }

        this.currentTool = tool;

        return true;
    }

    /**
     * 如果当前工具存在，先退出激活，然后清空
     * @method clearCurrentTool
     * @author zxf
     * @date   2021-11-25
     * @return {undefined}
     */
    clearCurrentTool() {
        if (this.currentTool) {
            this.currentTool.onDeactive();
            this.currentTool = null;
        }
    }

    /**
     * @Author: zxf
     * @description: 暂停当前工具
     * @param {*}
     * @return {*}
     */
    pause() {
        this.isRunning = false;
    }

    /**
     * @Author: zxf
     * @description: 继续当前工具
     * @param {*}
     * @return {*}
     */
    continue() {
        this.isRunning = true;
    }

    _onKeyDown(event) {
        if (!this.tagNames.hasOwnProperty(event.target.tagName) && event.code !== this.keyEventCode) {
            this.onKeyDown(event);
            // modified by chenx on 2017-8-31
            // 停止冒泡会导致hotkeys组件不可用
            // event.stopPropagation();
        }
        this.keyEventCode = event.code;
    };

    _onKeyUp(event) {
        if (!this.tagNames.hasOwnProperty(event.target.tagName)) {
            this.onKeyUp(event);
            // event.stopPropagation();
        }
        this.keyEventCode = null;
    };

    /**
     * @Author: zxf
     * @description: 
     * @param {*}
     * @return {*}
     */    
     _onMouseDown(event) {
        const buttonType = this.getButtonType(event.button);
        switch (buttonType) {
            case 'leftButton':
                this.dispatchEvent('onMouseDown', event);
                break;
            case 'rightButton':
                this.dispatchEvent('onRightButtonDown', event);
                break;
            default:
                throw new Error(`未知按键类型:${buttonType}`);
        }
    }

    _onPointerdown(event) {
      this.dispatchEvent('onPointerdown', event);
    }

    _onPointermove(event) {
      this.dispatchEvent('onPointermove', event);
    }
    
    _onPointerup(event) {
      this.dispatchEvent('onPointerup', event);
    }

    /**
     * @Author: zxf
     * @description: 
     * @param {*}
     * @return {*}
     */    
    _onMouseUp(event) {
        const buttonType = this.getButtonType(event.button);
        switch (buttonType) {
            case 'leftButton':
                this.dispatchEvent('onMouseUp', event);
                break;
            case 'rightButton':
                this.dispatchEvent('onMouseUp', event);
                break;
            default:
                throw new Error(`未知按键类型:${buttonType}`);
        }

        // 鼠标弹起的时候处理模拟click事件
        const now = new Date().getTime();
        const diffTime = now - this.lastClickTime;
        if (diffTime < this.dblClickTimeInterval) {
            this.onDblClick(event);
        } else {
            this.onClick(event);
            this.lastClickTime = now;
        }
    }

    /**
     * 事件响应函数
     * @method onMouseMove
     * @author Zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    _onMouseMove(event) {
        if(this.viewer.controls.pivot || this.viewer.controls.wheelDelta !== 0) {
            return;
        }
        this.dispatchEvent('onMouseMove', event);
    }

    /**
     * 事件响应函数
     * @method onWheel
     * @author zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onWheel(event) {
        this.dispatchEvent('onWheel', event);
    }

    /**
     * 事件响应函数
     * @method onClick
     * @author zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onClick(event) {
        const buttonType = this.getButtonType(event.button);
        switch (buttonType) {
            case 'leftButton':
                this.dispatchEvent('onMouseClick', event);
                break;
            case 'rightButton':
                this.dispatchEvent('onRightButtonClick', event);
                break;
            default:
                throw new Error(`未知按键类型:${buttonType}`);
        }
    }

    /**
     * 事件响应函数
     * @method onDblClick
     * @author xzf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onDblClick(event) {
        const buttonType = this.getButtonType(event.button);
        switch (buttonType) {
            case 'leftButton':
                this.dispatchEvent('onLeftButtonDblClick', event);
                break;
            case 'middleButton':
                this.dispatchEvent('onMiddleButtonDblClick', event);
                break;
            case 'rightButton':
                this.dispatchEvent('onRightButtonDblClick', event);
                break;
            default:
                throw new Error(`未知按键类型:${buttonType}`);
        }
    }

    /**
     * 事件响应函数
     * @method onKeyDown
     * @author zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onKeyDown(event) {
        this.dispatchEvent('onKeyDown', event);
        this.onKeyPress(event);
    }

    /**
     * 事件响应函数
     * @method onKeyUp
     * @author zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onKeyUp(event) {
        this.dispatchEvent('onKeyUp', event);
    }

    /**
     * 事件响应函数
     * @method onKeyPress
     * @author zxf
     * @date   2021-12-02
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    onKeyPress(event) {
        this.dispatchEvent('onKeyPress', event);
    }

    /**
     * 获取按键类型
     * @method getButtonType
     * @author zxf
     * @date   2021-12-02
     * @param  {number} button 按键类型
     * @return {string} 按键类型
     */
    getButtonType(button) {
        switch (button) {
            case 0:
                return 'leftButton';
            case 1:
                return 'middleButton';
            case 2:
                return 'rightButton';
            default:
                throw new Error(`未知按键类型:${button}`);
        }
    }

    /**
     * 事件派发函数
     * @method dispatchEvent
     * @author zxf
     * @date   2021-11-25
     * @param  {string} eventName 事件名
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    dispatchEvent(eventName, event) {
        if (this.currentTool && this.isRunning) {
            this.callEventHandler(this.currentTool, eventName, event);
        }
    }

    /**
     * 触发事件处理函数
     * @method callEventHandler
     * @author zxf
     * @date   2021-11-25
     * @param  {object} tool 地图工具
     * @param  {string} eventName 事件名
     * @param  {object} event 事件对象
     * @return {undefined}
     */
    callEventHandler(tool, eventName, event) {
        const eventMethod = tool[eventName];
        if (eventMethod) {
            try {
                eventMethod.call(tool, event);
            } catch (err) {
                console.error(err)
            }
        }
    }

    /**
     * 销毁单例对象
     * @method destroy
     * @author zxf
     * @date   2021-11-25
     * @return {undefined}
     */
    destroy() {
        this.unBindEvent();
        ToolController.instance = null;
        this.tools = {};
    }
}
